var map = {
	"./music-instructions.json": 3556,
	"./music-library-intro2024.json": 3557,
	"./music-library-launch2024.json": 3558,
	"./music-progression.json": 3559,
	"./startSourcesAdvanced.json": 3560,
	"./startSourcesSimple.json": 3561,
	"./startSourcesSimple2.json": 3562,
	"./startSourcesTracks.json": 3563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3328;